(function(){
var PHOTOS = {
cover:  "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/ccccccc.jpg?v=1784720677",
p04:    "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/Lorrie_Steven-8189.jpg?v=1784721355",
p08:    "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/main.jpg?v=1784725304",
p28:    "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/proposal.png?v=1785168473",
g1:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/Lorrie_Steven-8174.jpg?v=1784721337",
g2:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-52_1.jpg?v=1785415502",
g3:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-80_1.jpg?v=1785416473",
g4:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/mairie.jpg?v=1785415502",
g5:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-62_1.jpg?v=1785415502",
g6:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-82_1.jpg?v=1785416375",
end:    "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/just_married.png?v=1785169254",
qr:     "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/lVHO0F.jpg?v=1785416945",
free1:  "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-26_1.jpg?v=1785418752",
free2:  "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/jjeje.png?v=1785169057",
free3:  "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-55_1.jpg?v=1785418752",
free4:  "https://cdn.shopify.com/s/files/1/0991/3873/2381/files/MariageLorrie_Steven-46_1.jpg?v=1785418752"
};
function img(key, alt, cls){
var url = PHOTOS[key];
cls = cls || 'prl-ph-placeholder';
if (url) return '<img src="' + url + '" alt="' + (alt||'') + '">';
return '<div class="' + cls + '">Insérer image ici' + (alt ? '<br>— ' + alt : '') + '</div>';
}
function qrBlock(){
if (PHOTOS.qr) return '<div class="prl-qr"><img src="' + PHOTOS.qr + '" alt="QR code" style="width:100%;height:100%;object-fit:contain;"></div>';
return '<div class="prl-qr"><svg viewBox="0 0 29 29" shape-rendering="crispEdges">' +
'<rect width="29" height="29" fill="#fff"/>' +
'<g fill="#5E2B21">' +
'<rect x="0" y="0" width="7" height="7"/><rect x="1" y="1" width="5" height="5" fill="#fff"/><rect x="2" y="2" width="3" height="3"/>' +
'<rect x="22" y="0" width="7" height="7"/><rect x="23" y="1" width="5" height="5" fill="#fff"/><rect x="24" y="2" width="3" height="3"/>' +
'<rect x="0" y="22" width="7" height="7"/><rect x="1" y="23" width="5" height="5" fill="#fff"/><rect x="2" y="24" width="3" height="3"/>' +
'<rect x="9" y="1" width="2" height="2"/><rect x="13" y="1" width="2" height="2"/><rect x="17" y="1" width="2" height="2"/>' +
'<rect x="9" y="4" width="2" height="2"/><rect x="15" y="4" width="2" height="2"/>' +
'<rect x="11" y="9" width="2" height="2"/><rect x="15" y="9" width="2" height="2"/><rect x="19" y="9" width="2" height="2"/>' +
'<rect x="9" y="12" width="2" height="2"/><rect x="13" y="12" width="2" height="2"/><rect x="17" y="12" width="2" height="2"/><rect x="21" y="12" width="2" height="2"/>' +
'<rect x="11" y="15" width="2" height="2"/><rect x="15" y="15" width="2" height="2"/><rect x="9" y="17" width="2" height="2"/>' +
'<rect x="13" y="17" width="2" height="2"/><rect x="19" y="17" width="2" height="2"/>' +
'<rect x="9" y="20" width="2" height="2"/><rect x="17" y="20" width="2" height="2"/><rect x="21" y="20" width="2" height="2"/>' +
'<rect x="11" y="22" width="2" height="2"/><rect x="15" y="23" width="2" height="2"/><rect x="19" y="25" width="2" height="2"/><rect x="23" y="22" width="2" height="2"/>' +
'</g></svg></div>';
}
var CH = {
intro: {
kicker:'Introduction',
paras:[
"Ce matin, j'ai retrouvé le ticket de cinéma du 12 mars, glissé depuis huit ans entre les pages d'un livre que je n'ouvre jamais.",
"Huit ans. Et dans trois mois, ce sera pour la vie.",
"On m'a souvent demandé pourquoi j'écrivais notre histoire alors qu'on la connaît par cœur, tous les deux. Mais justement : je la connais par cœur, pas par écrit.",
"On l'a écrit à deux voix, littéralement : certains soirs c'est moi qui prenais le clavier pendant que Julien racontait, d'autres fois c'est l'inverse.",
"Voici notre histoire. La vraie. Faite de petits riens et de grands moments, sans filtre ni sous-titres."
]
},
avant: {
kicker:'Avant nous',
paras:[
"Avant, il y avait deux vies qui n'avaient aucune raison de se croiser.",
"Moi, Camille, j'avais grandi à Rennes, dans une famille où on ne parlait pas beaucoup mais où on s'aimait fort.",
"Julien, lui, venait de Lyon. Fils de commerçants, il avait grandi au-dessus de la boulangerie familiale, réveillé chaque matin par l'odeur du pain.",
"On avait chacun nos habitudes bien installées. On ne se cherchait même pas, et c'est peut-être pour ça que ça a fonctionné : on n'attendait rien, alors on a tout reçu.",
"Il y avait aussi deux grand-mères qui allaient jouer, sans le savoir, un rôle plus grand qu'on ne l'imaginait — dont le carnet de mariages que l'on garde aujourd'hui chez nous, avec une page laissée exprès pour la nôtre."
]
},
bascule: {
kicker:'Le jour où tout a basculé',
paras:[
"Le 12 mars, un mercredi, il pleuvait sur Nantes comme il pleut sur Nantes un mercredi de mars : sans conviction, mais sans s'arrêter non plus.",
"Julien était assis deux rangs devant, seul. À l'entracte, on s'est retrouvés côte à côte. « Vous avez suivi quelque chose, vous ? » m'a-t-il demandé. « Absolument rien », j'ai répondu.",
"On est sortis avant la fin, sans se concerter, et on a marché sous la pluie. En partant, il a dit : « Je crois que je viens de rater la fin d'un film pour la meilleure raison du monde. »",
"Le premier vrai rendez-vous a suivi dix jours plus tard. Il ne m'a pas embrassée ce soir-là. Il l'a fait la semaine suivante, sous l'auvent d'une boulangerie fermée.",
"On a mis presque deux mois avant de se présenter officiellement comme un couple. Personne n'a semblé surpris — tout le monde l'avait déjà deviné avant nous."
]
},
aimer: {
kicker:"Apprendre à s'aimer",
paras:[
"Les débuts n'ont rien eu d'un long fleuve tranquille. On avait chacun nos armures, et il a fallu du temps pour accepter de les poser.",
"Julien m'a arrêtée à la porte, un soir de dispute : « Tu peux partir si tu veux. Mais je préférerais qu'on reste et qu'on se dispute encore un peu. »",
"Un an après le cinéma, on a emménagé ensemble près du canal Saint-Félix. On mangeait des pâtes trois soirs sur quatre et on trouvait ça très bien.",
"On a dit « je t'aime » pour la première fois un soir de septembre, presque par accident, au milieu d'une phrase sur la liste de courses — entre le lait et le papier toilette.",
"Notre premier grand voyage a été un chaos organisé : deux semaines en Grèce réservées trois jours avant le départ. On est rentrés en se disant qu'on pouvait probablement survivre à peu près à tout."
]
},
soudes: {
kicker:'Ce qui nous a soudés',
paras:[
"On aimerait dire que tout a été facile après ça. Ce ne serait pas vrai, et on s'est promis, en écrivant ce livre, de ne rien enjoliver.",
"Il y a eu cette année où Julien a perdu son emploi du jour au lendemain. Ce qui nous a sauvés, ce n'est pas d'avoir eu toutes les bonnes réponses. C'est d'avoir accepté de ne pas les avoir, ensemble.",
"Il y a eu aussi la maladie de mon père. Mon père est parti un an plus tard. Julien a conduit huit heures pour être à mes côtés, se contentant de me tenir la main assez fort.",
"Il y a eu, aussi, une épreuve plus silencieuse : une période où on s'est éloignés sans vraiment s'en rendre compte. On en garde aujourd'hui une règle : ne jamais laisser passer plus de quelques jours sans se poser vraiment.",
"Il y a eu, avant cela, une année de distance imposée par le travail de Julien, envoyé six mois en Allemagne. On a tenu en se fixant des petits rituels — une photo du ciel envoyée chaque matin, pluie ou soleil."
]
},
riens: {
kicker:'Nos petits riens',
paras:[
"On ne se souviendra pas forcément, dans quarante ans, du jour exact de notre mariage. Mais on se souviendra sûrement de tout ce qui compose nos jours ordinaires.",
"Le rituel du dimanche matin : Julien qui descend chercher des croissants en pyjama, et qui revient toujours en annonçant qu'il a « failli » prendre un pain au chocolat, sans jamais le faire.",
"Il y a « faire un Georgien », notre expression à nous pour abandonner quelque chose en cours de route parce qu'on préfère se concentrer l'un sur l'autre.",
"Il y a Simone, notre chatte, adoptée impulsivement dans un refuge où on n'était entrés « que pour regarder ». Il y a Sarah et Mehdi, nos amis devenus une deuxième famille.",
"Il y a le 31 décembre, toujours passé à la maison, tous les deux, une tradition à laquelle on n'a jamais dérogé."
]
},
demain: {
kicker:'Demain, à deux',
paras:[
"Dans trois mois, on se dira oui devant nos familles, nos amis, et probablement une tante qui pleurera plus fort que tout le monde.",
"La demande, elle, n'a rien eu de scénarisé. On marchait sur les rochers à marée basse quand Julien s'est arrêté, sans prévenir, et a posé un genou à même la pierre mouillée : « Je voulais juste te demander, ici, si tu voulais continuer à se perdre avec moi, mais cette fois pour de vrai, jusqu'au bout. »",
"J'ai dit oui, en riant et en pleurant à moitié, au milieu des rochers, sans témoin sinon les mouettes.",
"Mon père m'a menée jusqu'à l'autel, pendant que Julien essayait très fort de ne pas pleurer devant tout le monde. Il n'a pas réussi.",
"Ce qu'on aimerait, en refermant ce livre, c'est que ceux qui le liront après nous comprennent une chose : l'amour n'est jamais arrivé tout fait. On l'a construit, jour après jour, dispute après dispute, croissant après croissant."
]
}
};
var LETTRE = [
"Si vous lisez ces lignes en 2066, vous avez probablement oublié la moitié de ce qu'on vient de raconter, et c'est très bien ainsi : c'est à ça que sert ce livre, à vous le redonner.",
"On espère que vous vous disputez encore pour la température de la chambre. On espère que Simone, ou une autre chatte après elle, dort encore sur le linge propre.",
"On espère surtout que vous vous souvenez au moins de cette certitude simple qu'on avait ce jour-là, au milieu des rochers : qu'on voulait continuer à se perdre ensemble, jusqu'au bout.",
"Avec tout notre amour, petits riens et grands moments compris. — Camille & Julien"
];
function faceBlank(){ return '<div class="prl-face prl-blank"></div>'; }
function faceCover(){
return '<div class="prl-face prl-cover">' +
'<div class="prl-cover-top">' +
'<div class="prl-cover-names">Camille &amp; Julien</div>' +
'<h2 class="prl-cover-title">PETITS RIENS<br>ET GRANDS MOMENTS</h2>' +
'</div>' +
'<div class="prl-cover-photo">' + img('cover','Camille et Julien, le jour du mariage','prl-placeholder') +
'<div class="prl-cover-hint">Cliquez pour ouvrir</div>' +
'</div>' +
'</div>';
}
function faceTitle(num){
return '<div class="prl-face prl-title"><div class="prl-ti-names">Camille &amp; Julien</div>' +
'<h2 class="prl-ti-main">PETITS RIENS<br>ET GRANDS MOMENTS</h2>' +
'<div class="prl-ti-rule"></div><div class="prl-ti-sub">Photo&nbsp;: Guillaume Fontaine</div>' +
'<div class="prl-pgnum">' + num + '</div></div>';
}
function faceDedic(num){
return '<div class="prl-face prl-dedic"><p>Pour nos enfants, plus tard.<br>Et pour nous-mêmes, quand on aura oublié.</p>' +
'<div class="prl-pgnum">' + num + '</div></div>';
}
function faceToc(num){
var items = [
['Introduction','ch-intro'],['Avant nous','ch-avant'],["Le jour où tout a basculé",'ch-bascule'],
["Apprendre à s'aimer",'ch-aimer'],['Ce qui nous a soudés','ch-soudes'],['Nos petits riens','ch-riens'],
['Demain, à deux','ch-demain'],['Album du jour','ch-gallery'],['Lettre à nous-mêmes','ch-lettre'],
["Et tant d'autres souvenirs",'ch-libre']
];
var rows = items.map(function(it,i){
return '<div class="prl-toc-row" data-goto="'+it[1]+'"><span class="prl-toc-t">'+it[0]+'</span><span class="prl-toc-d"></span><span class="prl-toc-n">'+(i+1)+'</span></div>';
}).join('');
return '<div class="prl-face"><div class="prl-toc-k">Sommaire</div><div class="prl-toc-list">'+rows+'</div>' +
'<div class="prl-pgnum">' + num + '</div></div>';
}
function faceDivider(numStr, title, num){
return '<div class="prl-face prl-div"><div><div class="prl-div-num">'+numStr+'</div>' +
'<div class="prl-div-line"></div><h2 class="prl-div-title">'+title+'</h2></div>' +
'<div class="prl-pgnum">' + num + '</div></div>';
}
function faceText(chapter, num){
var ps = chapter.paras.map(function(p){ return '<p>'+p+'</p>'; }).join('');
return '<div class="prl-face"><div class="prl-runhead">'+chapter.kicker+'</div>' +
'<div class="prl-body">'+ps+'</div><div class="prl-pgnum">' + num + '</div></div>';
}
function facePhoto(key, caption, num){
return '<div class="prl-face"><div class="prl-runhead">'+caption+'</div>' +
'<figure class="prl-photofig">' + img(key, caption) + '<figcaption>'+caption+'</figcaption></figure>' +
'<div class="prl-pgnum">' + num + '</div></div>';
}
function faceGallery(num){
var items = [
['g1',"un souvenir de leurs débuts"],
['g2',"le cortège, au bras de son père"],
['g3',"le musicien"],
['g4',"la mairie"],
['g5',"la sortie"],
['g6',"encore un peu de fête"]
];
var figs = items.map(function(it){
return '<figure><div class="prl-g-img">' + img(it[0], it[1]) + '</div><figcaption>'+it[1]+'</figcaption></figure>';
}).join('');
return '<div class="prl-face"><div class="prl-runhead">Album du jour</div>' +
'<div class="prl-gallery">'+figs+'</div><div class="prl-pgnum">' + num + '</div></div>';
}
function faceLettre(num){
var ps = LETTRE.map(function(p){ return '<p>'+p+'</p>'; }).join('');
return '<div class="prl-face"><div class="prl-runhead">Lettre à nous-mêmes, dans quarante ans</div>' +
'<div class="prl-body">'+ps+'</div><div class="prl-pgnum">' + num + '</div></div>';
}
function faceFreePages(num){
var keys = ['free1','free2','free3','free4'];
var cells = keys.map(function(k){
return '<div class="prl-free-cell">' + img(k, 'Un souvenir à ajouter') + '</div>';
}).join('');
return '<div class="prl-face"><div class="prl-runhead">Et tant d\'autres souvenirs</div>' +
'<div class="prl-free-grid">'+cells+'</div><div class="prl-pgnum">' + num + '</div></div>';
}
function faceEnd(num){
return '<div class="prl-face prl-end"><div class="prl-end-orn">❧</div>' +
'<p class="prl-end-text">Merci d\'avoir tourné ces pages avec nous.<br>La suite, on est plutôt pressés de l\'écrire, à deux.</p>' +
'<figure class="prl-end-fig">' + img('end','Camille et Julien, entourés des leurs') + '</figure>' +
'<div class="prl-end-sign">Camille &amp; Julien</div><div class="prl-pgnum">' + num + '</div></div>';
}
function faceBackCover(){
return '<div class="prl-face prl-back"><div class="prl-back-in">' +
'<h3 class="prl-back-h">Leur histoire</h3>' +
'<p class="prl-back-text">Camille et Julien se sont rencontrés un soir de pluie, dans une salle de cinéma à moitié vide. Huit ans plus tard, ils racontent tout&nbsp;: la rencontre, les premières disputes, les épreuves traversées à deux, et cette demande en mariage lancée au milieu des rochers, un jour de tempête. Un livre écrit à quatre mains, pour se souvenir — et pour transmettre.</p>' +
'<p class="prl-back-quote">« On voulait continuer à se perdre ensemble,<br>jusqu\'au bout. »</p>' +
'<div class="prl-back-bottom">' + qrBlock() +
'<div class="prl-back-brand"><span class="prl-back-bs">ma vie en</span><span class="prl-back-bb">LIVRE</span></div>' +
'</div>' +
'</div></div>';
}
var LEAVES = [
{ front: faceCover(),                                   back: faceBlank(),                       hard:true },
{ front: faceTitle('1'),                                back: faceDedic('2') },
{ front: faceToc('3'),                                  back: faceBlank() },
{ front: faceDivider('01','Introduction','4'),          back: faceBlank(),                       key:'ch-intro' },
{ front: faceText(CH.intro,'5'),                        back: facePhoto('p04','Camille et Julien, la main dans la main','6') },
{ front: faceDivider('02','Avant nous','7'),             back: faceBlank(),                       key:'ch-avant' },
{ front: faceText(CH.avant,'8'),                         back: facePhoto('p08',"les mains, l'alliance",'9') },
{ front: faceDivider('03',"Le jour où tout a basculé",'10'), back: faceBlank(),                   key:'ch-bascule' },
{ front: faceText(CH.bascule,'11'),                      back: faceBlank() },
{ front: faceDivider('04',"Apprendre à s'aimer",'12'),    back: faceBlank(),                      key:'ch-aimer' },
{ front: faceText(CH.aimer,'13'),                        back: faceBlank() },
{ front: faceDivider('05','Ce qui nous a soudés','14'),   back: faceBlank(),                      key:'ch-soudes' },
{ front: faceText(CH.soudes,'15'),                       back: faceBlank() },
{ front: faceDivider('06','Nos petits riens','16'),       back: faceBlank(),                      key:'ch-riens' },
{ front: faceText(CH.riens,'17'),                        back: faceBlank() },
{ front: faceDivider('07','Demain, à deux','18'),         back: facePhoto('p28','la demande, sur les rochers','19'), key:'ch-demain' },
{ front: faceText(CH.demain,'20'),                       back: faceBlank() },
{ front: faceGallery('21'),                               back: faceBlank(),                      key:'ch-gallery' },
{ front: faceLettre('22'),                                back: faceBlank(),                      key:'ch-lettre' },
{ front: faceFreePages('23'),                             back: faceBlank(),                      key:'ch-libre' },
{ front: faceEnd('24'),                                   back: faceBackCover(),                  hard:true }
];
var book = document.getElementById('prl-book');
var TOTAL = LEAVES.length;
var CHAP = {};
LEAVES.forEach(function(lf, i){
var el = document.createElement('div');
el.className = 'prl-leaf' + (lf.hard ? ' prl-hard' : '');
el.setAttribute('data-leaf', i);
el.style.zIndex = TOTAL - i;
el.innerHTML =
'<div class="prl-leaf-front">' + lf.front + '</div>' +
'<div class="prl-leaf-back">' + lf.back + '</div>';
book.appendChild(el);
if (lf.key) CHAP[lf.key] = i;
});
var leaves = Array.prototype.slice.call(book.querySelectorAll('.prl-leaf'));
var current = 0;
function isMobile(){ return window.matchMedia('(max-width:1080px)').matches; }
function renderDesktop(){
leaves.forEach(function(lf,i){
lf.style.left=''; lf.style.width=''; lf.style.transform='';
var fr=lf.querySelector('.prl-leaf-front'), bk=lf.querySelector('.prl-leaf-back');
if(fr) fr.style.display=''; if(bk) bk.style.display='';
if(i < current){ lf.classList.add('prl-flipped'); lf.style.zIndex=i+1; }
else { lf.classList.remove('prl-flipped'); lf.style.zIndex=TOTAL-i; }
});
if(current===0){ book.style.transform='translateX(-25%)'; }
else if(current===TOTAL){ book.style.transform='translateX(25%)'; }
else { book.style.transform='translateX(0)'; }
var bar=document.getElementById('prl-pbar'), lbl=document.getElementById('prl-plabel');
bar.style.width=(current/TOTAL*100)+'%';
document.getElementById('prl-prev').disabled=current===0;
document.getElementById('prl-next').disabled=current===TOTAL;
lbl.textContent = current===0 ? 'Couverture' : (current===TOTAL ? 'Quatrième de couverture' : 'Feuillet '+current+' / '+TOTAL);
}
var mobileFaces=[];
leaves.forEach(function(lf){
mobileFaces.push({el:lf.querySelector('.prl-leaf-front'),host:lf,side:'front'});
mobileFaces.push({el:lf.querySelector('.prl-leaf-back'),host:lf,side:'back'});
});
mobileFaces = mobileFaces.filter(function(f){
if(!f.el) return false;
var inner=f.el.firstElementChild;
if(!inner) return false;
return !inner.classList.contains('prl-blank');
});
var mIndex=0;
function renderMobile(){
leaves.forEach(function(lf){
lf.classList.remove('prl-flipped');
lf.style.transform='none';
lf.style.left='0'; lf.style.width='100%';
lf.style.zIndex='0';
var fr=lf.querySelector('.prl-leaf-front'), bk=lf.querySelector('.prl-leaf-back');
if(fr) fr.style.display='none';
if(bk) bk.style.display='none';
});
book.style.transform='none';
var f=mobileFaces[mIndex];
if(f){
f.host.style.zIndex='10';
if(f.side==='front'){ f.el.style.display='block'; f.host.style.transform='none'; }
else { f.el.style.display='block'; f.el.style.transform='rotateY(0deg)'; }
}
var bar=document.getElementById('prl-pbar'), lbl=document.getElementById('prl-plabel');
var last=mobileFaces.length-1;
bar.style.width=(mIndex/last*100)+'%';
document.getElementById('prl-prev').disabled=mIndex===0;
document.getElementById('prl-next').disabled=mIndex===last;
lbl.textContent = mIndex===0 ? 'Couverture' : (mIndex===last ? 'Quatrième de couverture' : 'Page '+mIndex+' / '+last);
}
function render(){ isMobile() ? renderMobile() : renderDesktop(); }
function next(){
if(isMobile()){ if(mIndex<mobileFaces.length-1){mIndex++;renderMobile();} }
else { if(current<TOTAL){current++;renderDesktop();} }
}
function prev(){
if(isMobile()){ if(mIndex>0){mIndex--;renderMobile();} }
else { if(current>0){current--;renderDesktop();} }
}
document.getElementById('prl-next').addEventListener('click',next);
document.getElementById('prl-prev').addEventListener('click',prev);
book.addEventListener('click',function(e){
if(e.target.closest('.prl-toc-row')) return;
var r=book.getBoundingClientRect();
(e.clientX-r.left > r.width/2) ? next() : prev();
});
document.addEventListener('keydown',function(e){
var modalEl=document.getElementById('prl-modal');
if(!modalEl || !modalEl.classList.contains('is-open')) return;
if(e.key==='ArrowRight'){ next(); }
if(e.key==='ArrowLeft'){ prev(); }
});
book.querySelectorAll('.prl-toc-row').forEach(function(row){
row.addEventListener('click',function(e){
e.stopPropagation();
var key = row.getAttribute('data-goto');
var idx = CHAP[key];
if (idx === undefined) return;
if(isMobile()){
for(var k=0;k<mobileFaces.length;k++){
if(mobileFaces[k].host === leaves[idx] && mobileFaces[k].side==='front'){ mIndex=k; renderMobile(); break; }
}
} else {
current = idx; renderDesktop();
}
});
});
var tx=null;
book.addEventListener('touchstart',function(e){tx=e.changedTouches[0].clientX;},{passive:true});
book.addEventListener('touchend',function(e){
if(tx===null) return;
var dx=e.changedTouches[0].clientX-tx;
if(Math.abs(dx)>40){ dx<0?next():prev(); }
tx=null;
},{passive:true});
leaves.forEach(function(lf){
if(!lf.classList.contains('prl-hard')){
var p=document.createElement('div'); p.className='prl-peel';
lf.querySelector('.prl-leaf-front').appendChild(p);
}
});
var rt;
window.addEventListener('resize',function(){
clearTimeout(rt);
rt=setTimeout(function(){ render(); },150);
});
window.addEventListener('orientationchange', function(){ setTimeout(render, 200); });
render();

var modal = document.getElementById('prl-modal');
var teaser = document.getElementById('prl-flipwrap');
var closeBtn = document.getElementById('prl-modal-close');

function goToFirstContentPage(){
current = 1;
mIndex = 1;
render();
}

function openBookModal(){
modal.classList.add('is-open');
document.body.style.overflow = 'hidden';
goToFirstContentPage();
}

function closeBookModal(){
modal.classList.remove('is-open');
document.body.style.overflow = '';
goToFirstContentPage();
}

teaser.addEventListener('click', openBookModal);
teaser.addEventListener('keydown', function(e){
if(e.key==='Enter' || e.key===' '){ e.preventDefault(); openBookModal(); }
});
closeBtn.addEventListener('click', closeBookModal);
modal.querySelectorAll('[data-prl-close]').forEach(function(el){
el.addEventListener('click', closeBookModal);
});
var modalPanel = document.querySelector('.prl-modal-panel');
modalPanel.addEventListener('click', function(e){
if(e.target === modalPanel){ closeBookModal(); }
});
document.getElementById('prl-flipbook').addEventListener('click', function(e){
if(e.target.id === 'prl-flipbook' || e.target.classList.contains('prl-stage')){ closeBookModal(); }
});
document.addEventListener('keydown', function(e){
if(e.key==='Escape' && modal.classList.contains('is-open')){ closeBookModal(); }
});
})();



(function(){
var FORMULE_PRICE = {59:59, 89:89, 169:169};
var COPY_PRICE = 25;
var famStepper = document.getElementById('pr-famille-stepper');
var famVal = document.getElementById('pr-step-val');
var famMinus = document.getElementById('pr-step-minus');
var famPlus = document.getElementById('pr-step-plus');
var famQty = 3;
function getPack(){
return document.querySelector('input[name="pr-pack"]:checked').value;
}
function getQty(){
var pack = getPack();
if (pack === '1') return 1;
if (pack === 'duo') return 2;
return famQty;
}
function updateFamStepperVisibility(){
famStepper.classList.toggle('is-visible', getPack() === 'famille');
}
famMinus.addEventListener('click', function(){
if (famQty > 3) { famQty--; famVal.textContent = famQty; updateTotal(); }
});
famPlus.addEventListener('click', function(){
if (famQty < 30) { famQty++; famVal.textContent = famQty; updateTotal(); }
});
function updateTotal(){
var formule = document.querySelector('input[name="pr-formule"]:checked').value;
var base = FORMULE_PRICE[formule];
var qty = getQty();
var total = base + (qty - 1) * COPY_PRICE;
document.getElementById('pr-total-amount').innerHTML =
total.toFixed(2).replace('.', ',') + '€' +
(qty > 1 ? ' <small>(' + qty + ' exemplaires)</small>' : '');
}
document.querySelectorAll('input[name="pr-formule"]').forEach(function(el){
el.addEventListener('change', updateTotal);
});
document.querySelectorAll('input[name="pr-pack"]').forEach(function(el){
el.addEventListener('change', function(){
updateFamStepperVisibility();
updateTotal();
});
});
updateFamStepperVisibility();
updateTotal();
})();


(function(){
  var btn = document.getElementById('pr-add-to-cart');
  if (!btn) return;

  function getPack(){
    return document.querySelector('input[name="pr-pack"]:checked').value;
  }
  function getFormule(){
    return document.querySelector('input[name="pr-formule"]:checked').value;
  }
  function getQty(){
    var pack = getPack();
    if (pack === '1') return 1;
    if (pack === 'duo') return 2;
    var famVal = document.getElementById('pr-step-val');
    return parseInt(famVal.textContent, 10);
  }

  function addToCart(){
    if (!window.prVariants) {
      console.error('prVariants introuvable — vérifiez le bloc Liquid en haut de la section.');
      alert("Erreur de configuration (prVariants manquant). Contactez le développeur.");
      return;
    }

    var formule = getFormule();
    var qty = getQty();
    var extraCopies = qty - 1;

    var items = [
      { id: window.prVariants.format[formule], quantity: 1 }
    ];
    if (extraCopies > 0) {
      items.push({ id: window.prVariants.exemplaireSupp, quantity: extraCopies });
    }

    btn.disabled = true;
    var originalHTML = btn.innerHTML;
    btn.innerHTML = 'Ajout en cours...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res){
      if (!res.ok) throw new Error('Erreur ajout panier');
      return res.json();
    })
    .then(function(data){
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-drawer-component');
      if (drawer) {
        drawer.open = true;
      }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: data.item_count, source: 'ma-vie-en-livre-form' } }
      }));
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    })
    .catch(function(err){
      console.error(err);
      alert("Une erreur est survenue lors de l'ajout au panier. Réessayez.");
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    });
  }

  btn.addEventListener('click', addToCart);
})();


(function(){
  // Les 3 formules sont fermées par défaut, même si "Moments Clés" reste
  // techniquement sélectionnée (pour le calcul du prix). L'ouverture ne se
  // fait qu'au clic, indépendamment de la sélection radio.
  var opts = document.querySelectorAll('.opt');
  if (!opts.length) return;

  opts.forEach(function(opt){
    var head = opt.querySelector('.opt-head');
    if (!head) return;

    head.addEventListener('click', function(){
      var willOpen = !opt.classList.contains('is-open');

      opts.forEach(function(o){ o.classList.remove('is-open'); });
      if (willOpen) opt.classList.add('is-open');

      var input = opt.querySelector('input[type="radio"]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();